import {
  EmojiCrystalBall,
  EmojiMagnifyingGlass,
  IconCircleQuestionMark,
} from '@hawkins/assets';
import {
  Button,
  Menu,
  MenuItem,
  TextLink,
} from '@hawkins/components';
import React from 'react';
import styles from './HelpMenu.module.css';

export const HelpMenu: React.FC = () => {
  return (
    <Menu
      position="bottom-end"
      showCaret
      trigger={
        <Button
          aria-label="Help Menu"
          icon={IconCircleQuestionMark}
          variant="icon"
        />
      }
    >
      <MenuItem className={styles.helpMenuItem}>
        <TextLink
          className={styles.helpMenuItemLink}
          href="https://partnerhelp.netflixstudios.com/hc/en-us/articles/4465014482323-Framing-Working-Resolution-Calculator-User-Guide"
          target="_blank"
        >
          <EmojiMagnifyingGlass />
          User Guide
        </TextLink>
      </MenuItem>
      <MenuItem className={styles.helpMenuItem}>
        <TextLink
          className={styles.helpMenuItemLink}
          href="https://netflix-studio.uservoice.com/forums/967028-framing-chart-generator"
          target="_blank"
        >
          <EmojiCrystalBall />
          Share Feedback & Ideas
        </TextLink>
      </MenuItem>
    </Menu>
  );
};

export default HelpMenu;
